import {Entity} from 'app/core/main.entity';
import {SwitchItem} from './switch.entity';
import {CustomDate} from '../core/classes/customDate';
import {ShiftState} from './enums';
import {Transform, Type} from 'class-transformer';

export class ShiftItem extends Entity {
  @Type(() => CustomDate)
  @Transform(({value}) => value ? new CustomDate(value) : null)
  startDate: CustomDate;

  @Type(() => CustomDate)
  @Transform(({value}) => value ? new CustomDate(value) : null)
  endDate: CustomDate;
}
